'use client';

import React, { useEffect, useRef } from 'react';

export default function BookingSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.1 }
    );
    sectionRef?.current?.querySelectorAll('.reveal-on-scroll')?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  useEffect(() => {
    // Load Tally embed script
    const existingScript = document.getElementById('tally-js');
    if (!existingScript) {
      const script = document.createElement('script');
      script.id = 'tally-js';
      script.src = 'https://tally.so/widgets/embed.js';
      script.async = true;
      script.onload = () => {
        if (typeof (window as any).Tally !== 'undefined') {
          (window as any).Tally.loadEmbeds();
        }
      };
      document.body.appendChild(script);
    } else {
      if (typeof (window as any).Tally !== 'undefined') {
        (window as any).Tally.loadEmbeds();
      }
    }
  }, []);

  return (
    <section
      ref={sectionRef}
      id="contact"
      style={{ background: '#111111', padding: '100px 64px' }}>

      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
          {/* Left: Info */}
          <div className="reveal-on-scroll">
            <div className="section-label">BOOK YOUR SESSION</div>
            <h2
              className="text-white"
              style={{
                fontFamily: 'Bebas Neue, sans-serif',
                fontSize: 'clamp(2.5rem, 5vw, 4.5rem)',
                lineHeight: 0.95,
                letterSpacing: '2px',
                marginBottom: '24px'
              }}>
              LET&apos;S BUILD{' '}
              <span style={{ color: '#FFFFFF' }}>SOMETHING</span>{' '}
              TOGETHER.
            </h2>
            <p
              style={{
                fontFamily: 'DM Sans, sans-serif',
                fontSize: '15px',
                color: 'rgba(255,255,255,0.5)',
                lineHeight: 1.7,
                marginBottom: '40px',
                maxWidth: '440px'
              }}>
              Whether you need photography, videography, live production, or a full branded experience — bring us your idea and we'll bring it to life.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 mb-12">
              {[
                { num: '100+', label: 'Sessions Done' },
                { num: 'Full', label: 'Production In-House' },
                { num: 'SWFL', label: 'Based & Beyond' }
              ]?.map((stat, i) =>
                <div key={i}>
                  <div
                    style={{
                      fontFamily: 'Bebas Neue, sans-serif',
                      fontSize: '32px',
                      letterSpacing: '2px',
                      color: '#FFFFFF',
                      lineHeight: 1,
                      marginBottom: '6px'
                    }}>
                    {stat.num}
                  </div>
                  <div
                    style={{
                      fontFamily: 'DM Sans, sans-serif',
                      fontSize: '12px',
                      color: 'rgba(255,255,255,0.4)',
                      letterSpacing: '1px'
                    }}>
                    {stat.label}
                  </div>
                </div>
              )}
            </div>

            {/* Contact info */}
            <div className="space-y-4">
              {[
                { label: 'Email', value: 'allywrk.brand@gmail.com' },
                { label: 'Instagram', value: '@allywrk' },
                { label: 'Response Time', value: 'Within 24 hours' },
                { label: 'Service Area', value: 'South West Florida' }
              ]?.map((info, i) =>
                <div key={i} className="flex items-center gap-4">
                  <span
                    style={{
                      fontFamily: 'Bebas Neue, sans-serif',
                      fontSize: '11px',
                      letterSpacing: '3px',
                      color: '#FFFFFF',
                      minWidth: '120px'
                    }}>
                    {info.label}
                  </span>
                  <span
                    style={{
                      fontFamily: 'DM Sans, sans-serif',
                      fontSize: '14px',
                      color: 'rgba(255,255,255,0.6)'
                    }}>
                    {info.value}
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* Right: Tally Embed */}
          <div className="reveal-on-scroll stagger-2">
            <iframe
              data-tally-src="https://tally.so/embed/MeGK5E?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
              loading="lazy"
              width="100%"
              height="500"
              frameBorder={0}
              marginHeight={0}
              marginWidth={0}
              title="Book a Session"
              style={{ minHeight: '500px', border: 'none' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}